export async function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = String(reader.result ?? '');
      const [, base64] = result.split(',');
      const format = (file.name.split('.').pop() ?? '').toLowerCase();
      resolve({ base64, format });
    };
    reader.onerror = () =>
      reject(reader.error ?? new Error('No se pudo leer el archivo'));
    reader.readAsDataURL(file);
  });
}